module.exports = __webpack_public_path__ + "static/media/promotional-menu-pricing.272ce940.svg";